import { RouteObjectRule } from "../router";
import { lazy, ReactNode, Suspense } from "react";
import { LuckLoading, LuckProgress } from '../../components/Luck';

export const lazyLoad = (children: ReactNode): ReactNode => {
	return (
		<Suspense fallback={
			<LuckProgress><LuckLoading /></LuckProgress>
		}>
			{children}
		</Suspense>
	)
}
const MeatIndex = lazy(() => import('../../pages/MentorBook/Meat/List'))
const MeatListAdd = lazy(() => import('../../pages/MentorBook/Meat/List/add'))
const MeatListEdit = lazy(() => import('../../pages/MentorBook/Meat/List/edit'))
const MeatCategory = lazy(() => import('../../pages/MentorBook/Meat/Category'))

const TeacherIndex = lazy(() => import('../../pages/MentorBook/Teacher'))
const TeacherAdd = lazy(() => import('../../pages/MentorBook/Teacher/add'))
const TeacherEdit = lazy(() => import('../../pages/MentorBook/Teacher/edit'))

const CommentIndex = lazy(() => import('../../pages/MentorBook/Comment'))
const CommentAdd = lazy(() => import('../../pages/MentorBook/Comment/add'))
const CommentEdit = lazy(() => import('../../pages/MentorBook/Comment/edit'))

const ProductIndex = lazy(() => import('../../pages/MentorBook/Product/List'))
const ProductListAdd = lazy(() => import('../../pages/MentorBook/Product/List/add'))
const ProductListEdit = lazy(() => import('../../pages/MentorBook/Product/List/edit'))
const ProductCategory = lazy(() => import('../../pages/MentorBook/Product/Category'))

//ms捷报
const Jiebao = lazy(() => import('../../pages/MentorBook/Jiebao'))
const JiebaoAdd = lazy(() => import('../../pages/MentorBook/Jiebao/add'))
const JiebaoEdit = lazy(() => import('../../pages/MentorBook/Jiebao/edit'))

//优惠券
const Coupon = lazy(() => import('../../pages/MentorBook/Coupon'))
const CouponAdd = lazy(() => import('../../pages/MentorBook/Coupon/add'))
const CouponEdit = lazy(() => import('../../pages/MentorBook/Coupon/edit'))

const Users = lazy(() => import('../../pages/MentorBook/User'));
const UserAdd = lazy(() => import('../../pages/MentorBook/User/add'))
const UserEdit = lazy(() => import('../../pages/MentorBook/User/edit'))

const GotousRouter: RouteObjectRule[] = [
	{
		path: "/mentorbook",
		children: [
			{
				path: "/mentorbook/teacher",
				element: lazyLoad(<TeacherIndex />)
			},
			{
				path: "/mentorbook/teacher/add",
				element: lazyLoad(<TeacherAdd />)
			},
			{
				path: "/mentorbook/teacher/edit/:id",
				element: lazyLoad(<TeacherEdit />)
			},


			{
				path: "/mentorbook/meat/list",
				element: lazyLoad(<MeatIndex />)
			},
			{
				path: "/mentorbook/meat/add",
				element: lazyLoad(<MeatListAdd />)
			},
			{
				path: "/mentorbook/meat/edit/:id",
				element: lazyLoad(<MeatListEdit />)
			},
			{
				path: "/mentorbook/meat/category",
				element: lazyLoad(<MeatCategory />)
			},


			{
				path: "/mentorbook/comment",
				element: lazyLoad(<CommentIndex />)
			},
			{
				path: "/mentorbook/comment/add",
				element: lazyLoad(<CommentAdd />)
			},
			{
				path: "/mentorbook/comment/edit/:id",
				element: lazyLoad(<CommentEdit />)
			},

			//产品
			{
				path: "/mentorbook/product/list",
				element: lazyLoad(<ProductIndex />)
			},
			{
				path: "/mentorbook/product/add",
				element: lazyLoad(<ProductListAdd />)
			},
			{
				path: "/mentorbook/product/edit/:id",
				element: lazyLoad(<ProductListEdit />)
			},
			{
				path: "/mentorbook/product/category",
				element: lazyLoad(<ProductCategory />)
			},
			{
				element: lazyLoad(<Jiebao />),
				path: '/mentorbook/jiebao',
			},
			{
				path: "/mentorbook/jiebao/add",
				element: lazyLoad(<JiebaoAdd />)
			},
			{
				path: "/mentorbook/jiebao/edit/:id",
				element: lazyLoad(<JiebaoEdit />)
			},
			{
				element: lazyLoad(<Coupon />),
				path: '/mentorbook/coupon',
			},
			{
				path: "/mentorbook/coupon/add",
				element: lazyLoad(<CouponAdd />)
			},
			{
				path: "/mentorbook/coupon/edit/:id",
				element: lazyLoad(<CouponEdit />)
			},
			{
				element: lazyLoad(<Users />),
				path: '/mentorbook/user',
			},
			{
				path: "/mentorbook/user/add",
				element: lazyLoad(<UserAdd />)
			},
			{
				path: "/mentorbook/user/edit/:id",
				element: lazyLoad(<UserEdit />)
			},
		]
	}
];

export default GotousRouter;